module.exports = __webpack_public_path__ + "static/img/88043fb9295db6795de9e283412793a6.partners3.1709800931122.png";